import { call, put, select, takeLatest } from 'redux-saga/effects'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { getPcrIdSelector } from '../../home/selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { saveSigner } from '../store/completeChart.actions'

export function* clearAllSignerData() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      signerDetails: [],
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(saveSigner())
    } catch (e) {
      yield put(throwPcrException(`clearAllSignerData() error: ${e}`))
    }
  }
}

export function* clearAllSignerDataSaga() {
  yield takeLatest(CompleteChartConstants.CLEAR_ALL_SIGNER_DATA, clearAllSignerData)
}
